var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"not-found"},[_c('span',[_vm._v("404")]),_c('h1',[_vm._v("페이지를 찾을 수 없습니다")]),_c('p',[_vm._v("주소가 변경되었거나 삭제된 페이지입니다.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("홈으로 돌아가기")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }